module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.questions), function(item, index) {
    return _c('div', {
      key: item.QST_NO,
      staticClass: "loop-tbl"
    }, [(item.INFOCD === _vm.getRadioCode) ? _c('div', {
      staticClass: "form-section mt-32"
    }, [_c('h3', {
      staticClass: "section-title"
    }, [_vm._v("추가 입력 내용" + _vm._s(item.QST_NO) + " "), _c('span', {
      staticClass: "must"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("추가입력내용 테이블" + _vm._s(item.QST_NO))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("질문")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.QST))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("답변")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio-group"
    }, _vm._l((_vm.getOptions(item.SELECTABLE_OPTIONS)), function(answer, radioIndex) {
      return _c('label', {
        key: radioIndex,
        staticClass: "radio-item",
        attrs: {
          "for": 'radio_' + item.QST_NO + '_' + radioIndex
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.ANSWER),
          expression: "item.ANSWER"
        }],
        staticClass: "sr-only",
        attrs: {
          "type": "radio",
          "id": 'radio_' + item.QST_NO + '_' + radioIndex,
          "name": 'radio_group_' + item.QST_NO,
          "disabled": _vm.isDisabled,
          "title": "선택 선택"
        },
        domProps: {
          "value": answer.trim(),
          "checked": _vm._q(item.ANSWER, answer.trim())
        },
        on: {
          "change": function($event) {
            _vm.$set(item, "ANSWER", answer.trim())
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-radio"
      }), _vm._v("\n                  " + _vm._s(answer) + "\n                ")])
    }), 0)])])])])])]) : _vm._e(), _vm._v(" "), (item.INFOCD === _vm.getCheckboxCode) ? _c('div', {
      staticClass: "form-section mt-32"
    }, [_c('h3', {
      staticClass: "section-title"
    }, [_vm._v("추가 입력 내용" + _vm._s(item.QST_NO))]), _vm._v(" "), _c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("추가입력내용 테이블" + _vm._s(item.QST_NO))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("질문")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.QST))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("답변")]), _vm._v(" "), _c('td', _vm._l((_vm.getOptions(item.SELECTABLE_OPTIONS)), function(option, checkIndex) {
      return _c('div', {
        key: checkIndex,
        staticClass: "check-wrap"
      }, [_c('input', {
        staticClass: "sr-only",
        attrs: {
          "type": "checkbox",
          "id": 'check' + index,
          "true-value": "Y",
          "false-value": "N",
          "disabled": _vm.isDisabled,
          "title": "선택 선택"
        },
        domProps: {
          "value": option,
          "checked": _vm.isChecked(option, item.ANSWER)
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": 'check' + index
        }
      }, [_c('span', [_vm._v(_vm._s(option))])])])
    }), 0)])])])])]) : _vm._e(), _vm._v(" "), (item.INFOCD === _vm.getShortTextCode) ? _c('div', {
      staticClass: "form-section mt-32"
    }, [_c('h3', {
      staticClass: "section-title"
    }, [_vm._v("추가 입력 내용" + _vm._s(item.QST_NO))]), _vm._v(" "), _c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("추가입력내용 테이블" + _vm._s(item.QST_NO))]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("질문")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.QST))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("답변")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ANSWER),
        expression: "item.ANSWER"
      }],
      attrs: {
        "type": "text",
        "placeholder": "답변을 입력해 주세요.",
        "disabled": _vm.isDisabled,
        "title": "답변(단문형)"
      },
      domProps: {
        "value": (item.ANSWER)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ANSWER", $event.target.value)
        }
      }
    })])])])])])])]) : _vm._e(), _vm._v(" "), (item.INFOCD === _vm.getLongTextCode) ? _c('div', {
      staticClass: "form-section mt-32"
    }, [_c('h3', {
      staticClass: "section-title"
    }, [_vm._v("추가 입력 내용" + _vm._s(item.QST_NO))]), _vm._v(" "), _c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("추가입력내용 테이블" + _vm._s(item.QST_NO))]), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("질문")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.QST))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("답변")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-area"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ANSWER),
        expression: "item.ANSWER"
      }],
      attrs: {
        "type": "text",
        "placeholder": "답변을 입력해 주세요.",
        "disabled": _vm.isDisabled,
        "title": "답변(장문형)",
        "name": "answer-sentence"
      },
      domProps: {
        "value": (item.ANSWER)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ANSWER", $event.target.value)
        }
      }
    })])])])])])])]) : _vm._e()])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7a33ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/AdditionalQuestions.vue
// module id = 1359
// module chunks = 6